import { render, staticRenderFns } from "./DeparturesPageBlumenau.vue?vue&type=template&id=3cfe5e3a&scoped=true&"
import script from "./DeparturesPageBlumenau.vue?vue&type=script&lang=js&"
export * from "./DeparturesPageBlumenau.vue?vue&type=script&lang=js&"
import style0 from "./DeparturesPageBlumenau.vue?vue&type=style&index=0&id=3cfe5e3a&prod&lang=css&"
import style1 from "./DeparturesPageBlumenau.vue?vue&type=style&index=1&id=3cfe5e3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfe5e3a",
  null
  
)

export default component.exports